{
  "clearSelection": "Clear selection",
  "selected": "{count, plural, =0 {None selected} other {# selected}}",
  "selectedAll": "All selected",
  "actions": "Actions",
  "actionsAvailable": "Actions available."
}
